import template from './order-details.html';
export var OrderDetailsComponent = {
    template: template,
    controller: /** @class */ (function () {
        /*@ngInject*/
        function OrderDetailsComponent($log, $stateParams, OrderDetailsService, Auth, CommonDataService) {
            var self = this;
            self.$log = $log;
            self.$stateParams = $stateParams;
            self.orderDetailsSvc = OrderDetailsService;
            self.Auth = Auth;
            self.$log.debug('I am here!!!' + self.$stateParams.orderId);
            self.orderId = self.$stateParams.orderId;
            self.createDate = self.$stateParams.createDate;
            self.orderDiscounts = null;
            self.commonDataService = CommonDataService;
            this.orderDetailsSvc.getOrderDiscounts(self.orderId).then(function (response) {
                self.orderDiscounts = response;
            });
            this.orderDetailsSvc.getOrderDetails(self.orderId, self.createDate)
                .then(function (response) {
                self.$log.debug('The order details are..', response);
                if (response) {
                    var notShippedItems = [];
                    var shippedItems = {};
                    for (var i = 0; i < response.shipments.length; i++) {
                        var shipment = response.shipments[i];
                        var lineItems = shipment.lineItems;
                        for (var j = 0; j < lineItems.length; j++) {
                            var lineItem = lineItems[j];
                            if (lineItem.quantityShipped > 0) {
                                lineItem.extendedAmount = lineItem.price * lineItem.quantityShipped;
                                if (!shippedItems[lineItem.shipmentNumber]) {
                                    shippedItems[lineItem.shipmentNumber] = {
                                        packageRefNumber: shipment.packageRefNumber,
                                        packages: shipment.packages,
                                        lineItems: [],
                                        invoiceNumber: null
                                    };
                                }
                                var shipment = shippedItems[lineItem.shipmentNumber];
                                shipment.lineItems.push(lineItem);
                                shipment.invoiceNumber = shipment.invoiceNumber || lineItem.printableInvoiceNumber;
                            }
                            if (lineItem.quantityOpenToShip > 0) {
                                lineItem.extendedAmount = lineItem.price * lineItem.quantityOpenToShip;
                                notShippedItems.push(lineItem);
                            }
                            if (lineItem.quantityOpenToShip === 0 && lineItem.quantityShipped === 0) {
                                lineItem.extendedAmount = lineItem.price * lineItem.quantityOrdered;
                                notShippedItems.push(lineItem);
                            }
                        }
                        self.commonDataService.addAttributeProductPathsForAllItems(lineItems);
                    }
                    self.order = response;
                    self.order.shipments = [];
                    for (var item in shippedItems) {
                        self.order.shipments.push(shippedItems[item]);
                    }
                    if (notShippedItems.length > 0) {
                        self.order.shipments.push({ packages: [{ status: 'Not yet shipped' }], lineItems: notShippedItems });
                    }
                    self.$log.debug('The order details are..', self.order.transactionNumber);
                }
                else {
                    self.order = {};
                }
            }, function (response) {
                self.order = {};
            });
            Auth.isLoggedIn(function (loggedInUser) {
                if (loggedInUser) {
                    self.loggedInUser = loggedInUser;
                }
            });
        }
        return OrderDetailsComponent;
    }())
};
//# sourceMappingURL=order-details.component.js.map